import Lara from '@primevue/themes/lara'
import { definePreset } from '@primevue/themes'

export const baseTheme = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{seaweed.50}',
            100: '{seaweed.100}',
            200: '{seaweed.200}',
            300: '{seaweed.300}',
            400: '{seaweed.400}',
            500: '{seaweed.500}',
            600: '{seaweed.600}',
            700: '{seaweed.700}',
            800: '{seaweed.800}',
            900: '{seaweed.900}',
            950: '{seaweed.950}',
        },
        litta: {
            primary: '{littaBlue.500}',
            primaryHover: '{littaBlue.600}',
        },
        bookingType: {
            booking: {
                background: '{lime.500}',
                text: '{lime.50}',
            },
            quote: {
                background: '{tuftBush.100}',
                text: '{tuftBush.600}',
            },
        },
        movementType: {
            delivery: {
                background: '#bfaefb',
                text: '#000000',
            },
            collection: {
                background: '#99E095',
                text: '#000000',
            },
            exchange: {
                background: '#d54402',
                text: '#FFFFFF',
            },
        },
        'movement-status': {
            'pending-submission': {
                background: '{gray.100}',
                text: '{gray.700}',
            },
            'awaiting-approval': {
                background: '#0D52AC',
                text: '#FFFFFF',
            },
            'supplier-approved': {
                background: '#39CAFF',
                text: '#000000',
            },
            'supplier-delivered': {
                background: '#99E095',
                text: '#000000',
            },
            failed: {
                background: '{rose.500}',
                text: '{rose.50}',
            },
        },
        'booking-status': {
            quote: {
                background: '{tuftBush.100}',
                text: '{tuftBush.600}',
            },
            'not-started': {
                background: '{gray.100}',
                text: '{gray.700}',
            },
            'in-progress': {
                background: '#ffba05',
                text: '{black}',
            },
            complete: {
                background: '#048a0e',
                text: '{green.50}',
            },
            failed: {
                background: '{rose.500}',
                text: '{rose.50}',
            },
        },
        deliveryType: {
            standard: {
                background: '{pink.500}',
                text: '{pink.50}',
            },
            waitAndLoad: {
                background: '#7B37EF',
                text: '#FFFFFF',
            },
        },
        commercial: '#00C07B',
        business: '#D74262',
        residential: '{littaBlue.500}',
        background: '#f6f9fa',
        ontime: '#10921E',
        early: '#FFB10F',
        late: '#A40033',
        complete: '#10921E',
        cancelled: '#dd2c5a',
        neutral: '#808080',
    },
    primitive: {
        razzmatazz: {
            50: '#F6B4D0',
            100: '#F4A2C4',
            200: '#F07DAD',
            300: '#EC5996',
            400: '#E8347F',
            500: '#DA1969',
            600: '#B51557',
            700: '#911146',
            800: '#6C0C34',
            900: '#480822',
            950: '#35061A',
        },
        tuftBush: {
            50: '#FFECE0',
            100: '#FFE0CC',
            200: '#FFC199',
            300: '#FFA266',
            400: '#FF8333',
            500: '#FF6400',
            600: '#CC5000',
            700: '#993C00',
            800: '#662800',
            900: '#331400',
            950: '#1A0A00',
        },
        littaBlue: {
            50: '#8EFCFC',
            100: '#7AFBFB',
            200: '#52FAFA',
            300: '#2BF9F9',
            400: '#07F4F4',
            500: '#06CCCC',
            600: '#05A4A4',
            700: '#047D7D',
            800: '#035555',
            900: '#012D2D',
            950: '#011A1A',
        },
        seaweed: {
            50: '#EFFBFA',
            100: '#D4F7F4',
            200: '#A1F7EF',
            300: '#51FBEB',
            400: '#00CCB9',
            500: '#003732',
            600: '#002925',
            700: '#001F1C',
            800: '#001715',
            900: '#000F0E',
            950: '#000807',
        },
    },
})
